import { USERLIST_URLS } from '../../config/config'
import { getIdToken, loginRefreshToken, setUser } from '../LoginUser'
import { UserRequest } from './UserRequestUtil'

export const listUsers = async (type) => {

  // try{
  //   let res = await userListRequest(type);
  //   const json = await res.json();
  //
  //   return convertUserListFormat(json);
  //
  // }catch(err){
  //     console.log("listUsers",err);
  //     return needLoginForError(err);
  // }
  const url = USERLIST_URLS[type];


  const parameter = {
    filters: {},
    start: 0,
    amount: 100
  };

  try {
    const res = await UserRequest(url, parameter)

    if(res){
      return convertUserListFormat(await res.json());
    }else{
      return res;
    }
  }catch(err){
    console.log(err);
    return
  }
};

const needLoginForError = (err) => {
  const  result = {
    count: 0,
    data: [],
    detail: {
      ...err
    },
    error: "Loginが必要です",
    needLogin: true,
  };
};

// const userListRequest = async (type) => {
//   const url = USERLIST_URLS[type];
//
//
//   const parameter = {
//     filters: {},
//     start: 0,
//     amount: 100
//   };
//
//     const res = await UserRequest(url,parameter)
//
//     return res;
//
// }


const convertUserListFormat = (resJson) => {

  if(!('UserAmount' in resJson)){
    return needLoginForError({});
  }

  let result = {
    count: resJson.UserAmount,
  };
  const users = resJson.Users.map((item) => {
    return {
      id: item.Attributes.sub,
      uid:  item.Username,
      tenantid: item.Attributes["custom:tenant"],
      familyname: item.Attributes.family_name,
      lastname: item.Attributes.given_name,
      email:  item.Attributes.email,
      isAvailable:  !item.Attributes.isLock,
      entrytime:  item.Attributes.created_at
    };
  });
  result.data = users;

  return result

}